/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "6dd7fce2f20c8d220df5676800a8d9c19a431649";
